<h1>Colors</h1>

<div class="uikit__colors">
  <div class="uikit__colors--blue">#1274D1</div>

  <div class="uikit__colors--green">#0BB161</div>

  <div class="uikit__colors--orange">#F5A623</div>

  <div class="uikit__colors--red">#D11212</div>

  <div class="uikit__colors--lightblue">
    #1274D1
    <br />
    20%
  </div>

  <div class="uikit__colors--lightorange">
    #F5A623
    <br />
    15%
  </div>

  <div class="uikit__colors--black">#333333</div>

  <div class="uikit__colors--darkblue">#19304F</div>

  <div class="uikit__colors--grey">#949494</div>

  <div class="uikit__colors--lightgrey">#EDEDED</div>

  <div class="uikit__colors--light">#F9FAFA</div>

  <div class="uikit__colors--white">#FFFFFF</div>
</div>

<h1>Typography</h1>

<div class="uikit__typography">
  <h1 class="title">Title 1 - 32/36</h1>

  <h3 class="title">Subtitle - black - 18</h3>

  <p class="regular">Paragraph - regular - 14</p>

  <span class="hint">Hint text - regular - 12</span>

  <h2 class="title--grey">Title 2 - 32/36</h2>

  <div class="list-element--bold">List element - bold - 14/18/24</div>

  <p class="bold">Paragraph - bold - 14</p>

  <h2 class="title--blue">Title 3 - 28/36</h2>

  <div class="list-element">List element - regular - 14/18/24</div>

  <span class="link">Link - bold - 14</span>
</div>

<h1>Buttons</h1>

@for (btn of buttons; track btn) {
  <h3>{{ btn.title }}</h3>
  <div style="margin-bottom: 12px">
    <app-lex-button color="green" [size]="btn.type"> button </app-lex-button>
  </div>
  <div class="uikit__buttons">
    @for (color of btn.colors; track color) {
      <div>
        <app-lex-button [color]="color" [size]="btn.type"> button </app-lex-button>
        <div class="button-helptext">normal</div>
      </div>
      <div>
        <app-lex-button [color]="color" [size]="btn.type" buttonClass="hover">
          button
        </app-lex-button>
        <div class="button-helptext">hover</div>
      </div>
      <div>
        <app-lex-button [color]="color" [size]="btn.type" buttonClass="active">
          button
        </app-lex-button>
        <div class="button-helptext">pressed</div>
      </div>
      <div>
        <app-lex-button [color]="color" [size]="btn.type" buttonClass="focus">
          button
        </app-lex-button>
        <div class="button-helptext">focus</div>
      </div>
      <div>
        <app-lex-button [color]="color" [size]="btn.type" disabled="true"> button </app-lex-button>
        <div class="button-helptext">disabled</div>
      </div>
      <div>
        <app-lex-button [color]="color" [size]="btn.type" [loading]="true"> button </app-lex-button>
        <div class="button-helptext">loading</div>
      </div>
    }
  </div>
}

<div class="uikit__icon-buttons">
  <div class="uikit__icon-buttons--icons">
    <h3 class="uikit__icon-buttons--icons-header">Icon</h3>

    <div>
      <app-lex-icon-button color="blue" matIcon="add"></app-lex-icon-button>

      <div class="button-helptext">normal</div>
    </div>

    <div>
      <app-lex-icon-button color="blue" matIcon="add" buttonClass="hover"></app-lex-icon-button>

      <div class="button-helptext">hover</div>
    </div>

    <div>
      <app-lex-icon-button color="blue" matIcon="add" buttonClass="active"></app-lex-icon-button>

      <div class="button-helptext">pressed</div>
    </div>

    <div>
      <app-lex-icon-button color="blue" matIcon="add" buttonClass="focus"></app-lex-icon-button>

      <div class="button-helptext">focus</div>
    </div>

    <div>
      <app-lex-icon-button color="blue" matIcon="add" disabled></app-lex-icon-button>

      <div class="button-helptext">disabled</div>
    </div>

    <div><!-- placeholder --></div>
  </div>

  <div class="uikit__icon-buttons--misc">
    <h3 class="uikit__icon-buttons--icons-header">Tag management / Filter elements</h3>

    <div style="grid-column: 1 / span 3">
      <app-lex-tag-button type="addable">Add this element</app-lex-tag-button>

      <div class="button-helptext">add</div>
    </div>

    <div style="grid-column: 4 / span 3">
      <app-lex-tag-button type="deletable">Delete this element</app-lex-tag-button>

      <div class="button-helptext">delete</div>
    </div>

    <div style="grid-column: 1 / span 2">
      <app-lex-tag-button type="language">EN</app-lex-tag-button>

      <div class="button-helptext">language tag</div>
    </div>

    <div style="grid-column: 3 / span 2">
      <app-lex-tag-button type="route">Product CR</app-lex-tag-button>

      <div class="button-helptext">route tag with icon</div>
    </div>

    <div style="grid-column: 5 / span 2">
      <app-lex-tag-button type="manual">Reddit</app-lex-tag-button>

      <div class="button-helptext">manual tag</div>
    </div>

    <div style="grid-column: 1 / span 6">
      <app-lex-tag-button type="small">turned off</app-lex-tag-button>

      <div class="button-helptext">add</div>
    </div>
  </div>
</div>

<h1>Fields</h1>
<h3>Inputs</h3>
<div class="uikit__fields">
  <div>
    <app-lex-input value="Placeholder">Label</app-lex-input>

    <div class="button-helptext">normal</div>
  </div>

  <div>
    <app-lex-input value="Placeholder" inputClass="hover">Label</app-lex-input>

    <div class="button-helptext">hover</div>
  </div>

  <div>
    <app-lex-input placeholder="Placeholder" value="Filled">Label</app-lex-input>

    <div class="button-helptext">filled</div>
  </div>

  <div>
    <app-lex-input placeholder="Hint text" inputClass="focus" [required]="true"
      >Label</app-lex-input
    >

    <div class="button-helptext">focus</div>
  </div>

  <div>
    <app-lex-input placeholder="Hint text" value="Typin'" [formControl]="activeControl"
      >Label</app-lex-input
    >

    <div class="button-helptext">active</div>
  </div>

  <div>
    <app-lex-input
      placeholder="Hint text"
      value="Typin'"
      [formControl]="errorControl"
      [validatorMessages]="{ required: 'This field is required' }"
      >Label</app-lex-input
    >

    <div class="button-helptext">error</div>
  </div>

  <div>
    <app-lex-input placeholder="Hint text" [disabled]="true" [required]="true">Label</app-lex-input>

    <div class="button-helptext">disabled</div>
  </div>
</div>

<h3>Dropdown</h3>
<div class="uikit__fields">
  <div>
    <app-lex-select placeholder="Hint text" [options]="selectOptions" [value]="selectOptions[0]"
      >Label</app-lex-select
    >

    <div class="button-helptext">normal</div>
  </div>

  <div>
    <app-lex-select
      placeholder="Hint text"
      [options]="selectOptions"
      [value]="selectOptions[0]"
      inputClass="hover"
      >Label</app-lex-select
    >

    <div class="button-helptext">hover</div>
  </div>

  <div>
    <app-lex-select placeholder="Hint text" [options]="selectOptions" [value]="selectOptions[1]"
      >Label</app-lex-select
    >

    <div class="button-helptext">filled</div>
  </div>

  <div>
    <app-lex-select
      placeholder="Hint text"
      [options]="selectOptions"
      inputClass="focus"
      [required]="true"
      >Label</app-lex-select
    >

    <div class="button-helptext">focus</div>
  </div>

  <div>
    <app-lex-select placeholder="Hint text" [options]="selectOptions" [formControl]="selectControl"
      >Label</app-lex-select
    >

    <div class="button-helptext">active</div>
  </div>
</div>

<h1>Table layout --- lextable</h1>
<app-lex-table
  [columns]="tableColumns"
  [rows]="[config]"
  [actions]="tableActions"
  class="uikit__config-table"
>
  <ng-template appLexTableCell="name" let-config>
    <app-lex-tag-button type="language" [tooltip]="config.language_name">
      {{ config.language_id | uppercase }}
    </app-lex-tag-button>

    <div [matTooltip]="config.name" class="lex-flex-table__config-name">
      <ng-container *appMiddleEllipsize="config.name"></ng-container>
    </div>
  </ng-template>

  <ng-template appLexTableCell="tags" let-config>
    @for (route of config.config_routes; track route) {
      <app-lex-tag-button type="route">
        {{ route.config_route_name }}
      </app-lex-tag-button>
    }
    @for (tag of config.tags; track tag) {
      <app-lex-tag-button type="manual">{{ tag }}</app-lex-tag-button>
    }

    <app-lex-tag-button type="manual-etc"> +2 </app-lex-tag-button>
  </ng-template>

  <ng-template appLexTableCell="createdBy"> John Smith </ng-template>

  <ng-template appLexTableCell="lastUsed" let-config>
    {{ config.modification_date | lexDate: 'short' }}
  </ng-template>
</app-lex-table>

<app-lex-table
  [columns]="denseTableColumns"
  [rows]="[project]"
  [dense]="true"
  class="uikit__config-table--dense"
>
  <ng-template appLexTableCell="name-dense">
    <div [matTooltip]="project.name" class="lex-flex-table__config-name">
      <ng-container *appMiddleEllipsize="project.name"></ng-container>
    </div>
  </ng-template>

  <ng-template appLexTableCell="lastUsed-dense">
    {{ project.updated | lexDate: 'short' }}
  </ng-template>

  <ng-template appLexTableCell="link-dense"> Go to Project </ng-template>
</app-lex-table>

<h1>Table layout --- CSS</h1>
<div class="lex-flex-table">
  <div class="lex-flex-table__header">
    <div class="lex-flex-table__column lex-flex-table__column--name">Name</div>

    <div class="lex-flex-table__column lex-flex-table__column--tags">Tags</div>

    <div class="lex-flex-table__column lex-flex-table__column--createdBy">Created by</div>

    <div class="lex-flex-table__column lex-flex-table__column--lastUsed">Last used</div>
  </div>
  <mat-action-list role="list">
    <button
      mat-list-item
      role="listitem"
      (click)="toggleSelectedConfiguration(config)"
      class="lex-flex-table__row"
      [class.lex-flex-table__row--selected]="selectedConfig === config"
    >
      <div class="lex-flex-table__column lex-flex-table__column--name">
        <app-lex-tag-button type="language" [tooltip]="config.language_name">
          {{ config.language_id | uppercase }}
        </app-lex-tag-button>

        <div [matTooltip]="config.name" class="lex-flex-table__config-name">
          <ng-container *appMiddleEllipsize="config.name"></ng-container>
        </div>
      </div>

      <div class="lex-flex-table__column lex-flex-table__column--tags">
        @for (route of config.config_routes; track route) {
          <app-lex-tag-button type="route">
            {{ route.config_route_name }}
          </app-lex-tag-button>
        }
        @for (tag of config.tags; track tag) {
          <app-lex-tag-button type="manual">{{ tag }}</app-lex-tag-button>
        }

        <app-lex-tag-button type="manual-etc"> +2 </app-lex-tag-button>
      </div>

      <div class="lex-flex-table__column lex-flex-table__column--createdBy">John Smith</div>

      <div class="lex-flex-table__column lex-flex-table__column--lastUsed">
        {{ config.modification_date | lexDate: 'short' }}
      </div>

      <div class="lex-flex-table__actions">
        <app-lex-icon-button matIcon="download"></app-lex-icon-button>

        <app-lex-icon-button matIcon="content_copy"></app-lex-icon-button>
      </div>
    </button>
  </mat-action-list>
</div>

<div class="lex-flex-table lex-flex-table--dense">
  <div class="lex-flex-table__header">
    <div class="lex-flex-table__column lex-flex-table__column--name-dense">Name</div>

    <div class="lex-flex-table__column lex-flex-table__column--lastUsed-dense">Last used</div>

    <div class="lex-flex-table__column lex-flex-table__column--link-dense"></div>
  </div>
  <mat-action-list role="list">
    <button mat-list-item role="listitem" class="lex-flex-table__row">
      <div class="lex-flex-table__column lex-flex-table__column--name-dense">
        <div [matTooltip]="project.name" class="lex-flex-table__config-name">
          <ng-container *appMiddleEllipsize="project.name"></ng-container>
        </div>
      </div>

      <div class="lex-flex-table__column lex-flex-table__column--lastUsed-dense">
        {{ project.updated | lexDate: 'short' }}
      </div>

      <div class="lex-flex-table__column lex-flex-table__column--link-dense">Go to Project</div>
    </button>
  </mat-action-list>
</div>

<h1>Code editor</h1>
<code-editor
  [(ngModel)]="codeContent"
  [lineWrapping]="true"
  [setup]="'basic'"
  [language]="'javascript'"
></code-editor>
